<template>
  <section id="order">
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="9" xl="9">
            <div class="text-center mt-10">
              <h1 class="section-title font-weight-light">4 шага получить налоговый вычет</h1>
            </div>
            <div class="row mt-10 align-center justify-center steps">
              <div class="d-flex col-sm-12 col-md-12 col-lg-6 col-xl-6 col-12">
                <table class="order-info-table">
                  <tr class="border-tr">
                    <td class="title" colspan="4">Вы</td>
                  </tr>
                  <tr>
                    <td class="img-info">
                      <div class="v-avatar rounded-0 d-none d-sm-flex">
                        <v-img :eager="true" src="@/assets/image/order1.png"></v-img>
                      </div>
                    </td>
                    <td class="text-info">
                      <h4>1. Оставляете<br>заявку</h4>
                      <p>Ответим на вопросы, подготовим Договор и список документов для декларации.</p>
                    </td>
                    <td class="img-info">
                      <div class="v-avatar rounded-0 d-none d-sm-flex">
                        <v-img :eager="true" src="@/assets/image/order2.png"></v-img>
                      </div>
                    </td>
                    <td class="text-info">
                      <h4>2. Отправляете<br>документы</h4>
                      <p>Помогаем собрать документы и проверяем их.</p>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="d-flex col-sm-12 col-md-12 col-lg-6 col-xl-6 col-12">
                <table class="order-info-table">
                  <tr class="border-tr">
                    <td class="title" colspan="4">Мы</td>
                  </tr>
                  <tr>
                    <td class="img-info">
                      <div class="v-avatar rounded-0 d-none d-sm-flex">
                        <v-img :eager="true" src="@/assets/image/order3.png"></v-img>
                      </div>
                    </td>
                    <td class="text-info">
                      <h4>3. Получаете<br>декларацию</h4>
                      <p>Заполняем декларацию и отправляем ее вам.</p>
                    </td>
                    <td class="img-info">
                      <div class="v-avatar rounded-0 d-none d-sm-flex">
                        <v-img :eager="true" src="@/assets/image/order4.png"></v-img>
                      </div>
                    </td>
                    <td class="text-info">
                      <h4>4. Подаете<br>декларацию</h4>
                      <p>Отправляем декларацию в налоговую, или вы сдаете ее сами.</p>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="9" xl="9" class="mt-10">
            <div class="text-center">
              <h2 class="section-title-2 font-weight-light">Вы получаете налоговый вычет</h2>
              <p class="mt-3 font-weight-light">Деньги придут на карту в течение 4-х месяцев</p>
              <v-btn class="order-btn mt-2" large dark @click="$vuetify.goTo('#request')">Получить налоговый вычет</v-btn>
            </div>

          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss">

section {
  position: relative;
  margin-bottom: 50px;
}

.section-title {
  color: #505050;
  font-size: 28px;
  font-weight: 400;
  text-transform: uppercase !important;
}

.section-title-2 {
  color: #005096;
  font-size: 24px;
  font-weight: 400;
  text-transform: uppercase !important;
}

.order-btn{
  background-color: #c42234 !important;
}

.order-info-table {
  width: 100%;

  .border-tr {

  }

  .title {
    text-align: center;
    font-size: 24px !important;
    border-bottom: 2px solid #005096;
    padding-bottom: 5px;
    color: #005096;
  }

  .img-info {
    padding: 7px;
    vertical-align: top;
  }

  .text-info {
    padding: 7px;
    vertical-align: top;

    p {
      font-size: 12px;
    }
  }
}
</style>
